module.exports = __webpack_public_path__ + "media/images/front/about/icon04-58e52556fe828670f8c8c9888d325c52.png";